module.exports = __webpack_public_path__ + "img/94.5.COD.a89fb509.png";